export default __webpack_public_path__ + "static/media/bg-min.a3b9079a.png";